module.exports = __webpack_public_path__ + "static/intro_dictionary_sky_bg_mobile-25e378f3543a04f0d9caf3a195964289.svg";